import { lazy } from 'react'

const PosterOrders = lazy(() => import('../../views/poster/PosterOrders'))
const PosterOrderDetails = lazy(() =>
  import('../../views/poster/PosterOrderDetails')
)

export const posterRoutes = [
  {
    path: 'poster/orders',
    element: <PosterOrders />,
    role: 'poster',
  },
  {
    path: 'poster/order/details/:orderId',
    element: <PosterOrderDetails />,
    role: 'poster',
  },
]
